<template>
  <div class="container">
    <h3 class="text-center">{{ text }}</h3>
    <TextInput
      fill
      class="mt-3"
      centered-text
      :max-length="4"
      placeholder="1234"
      @keydown="numbersOnly"
      :value="modelValue"
      @update:value="updateValue"
      :input-style="{ 'letter-spacing': '6px' }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import TextInput from "@/apps/credit-line/components/TextInput.vue";

export default defineComponent({
  name: "CcPinInput",
  components: { TextInput },
  props: {
    text: String,
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  methods: {
    numbersOnly(event) {
      event = event ? event : window.event;
      if (
        event.key !== "Enter" &&
        event.key !== "Backspace" &&
        event.key !== "Delete" &&
        event.key != parseInt(event.key)
      ) {
        event.preventDefault();
      } else {
        return true;
      }
    },
    updateValue(value: string) {
      this.$emit("update:modelValue", value);
    },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
</style>
